import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SecurityMetrics as StyledMetrics,
  LiveSecurityStatus,
  StatusIndicator,
  SecurityStats,
  SecurityStatItem,
  StatValue,
  SecurityStatLabel,
  ComplianceGrid,
  ComplianceBadge,
  BadgeIcon,
  BadgeTitle,
  BadgeDescription
} from './styles';

interface SecurityMetricsProps {
  encryptionDemo: boolean;
}

const SecurityMetrics: React.FC<SecurityMetricsProps> = ({ encryptionDemo }) => {
  const { t } = useTranslation();

  return (
    <StyledMetrics>
      <LiveSecurityStatus>
        <StatusIndicator>
          <div className="status-dot pulse"></div>
          <span>{t('security.status')}</span>
        </StatusIndicator>

        <SecurityStats>
          <SecurityStatItem>
            <StatValue>{t('security.metrics.encryption.value')}</StatValue>
            <SecurityStatLabel>{t('security.metrics.encryption.label')}</SecurityStatLabel>
          </SecurityStatItem>
          <SecurityStatItem>
            <StatValue>{t('security.metrics.uptime.value')}</StatValue>
            <SecurityStatLabel>{t('security.metrics.uptime.label')}</SecurityStatLabel>
          </SecurityStatItem>
          <SecurityStatItem>
            <StatValue>{t('security.metrics.breaches.value')}</StatValue>
            <SecurityStatLabel>{t('security.metrics.breaches.label')}</SecurityStatLabel>
          </SecurityStatItem>
          <SecurityStatItem>
            <StatValue>{t('security.metrics.certification.value')}</StatValue>
            <SecurityStatLabel>{t('security.metrics.certification.label')}</SecurityStatLabel>
          </SecurityStatItem>
        </SecurityStats>
      </LiveSecurityStatus>

      <ComplianceGrid>
        <ComplianceBadge $delay={0}>
          <BadgeIcon>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" />
            </svg>
          </BadgeIcon>
          <BadgeTitle>{t('security.certifications.meta.title')}</BadgeTitle>
          <BadgeDescription>{t('security.certifications.meta.description')}</BadgeDescription>
        </ComplianceBadge>

        <ComplianceBadge $delay={100}>
          <BadgeIcon>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L9 9L1 9L7.5 14L5 22L12 17L19 22L16.5 14L23 9L15 9L12 1Z" />
            </svg>
          </BadgeIcon>
          <BadgeTitle>{t('security.certifications.google.title')}</BadgeTitle>
          <BadgeDescription>{t('security.certifications.google.description')}</BadgeDescription>
        </ComplianceBadge>

        <ComplianceBadge $delay={200}>
          <BadgeIcon>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2M12 20C16.42 20 20 16.42 20 12S16.42 4 12 4 4 7.58 4 12 7.58 20 12 20M15.88 8.29L10 14.17L8.12 12.29L6.71 13.71L10 17L17.3 9.71L15.88 8.29Z" />
            </svg>
          </BadgeIcon>
          <BadgeTitle>{t('security.certifications.lgpd.title')}</BadgeTitle>
          <BadgeDescription>{t('security.certifications.lgpd.description')}</BadgeDescription>
        </ComplianceBadge>

        <ComplianceBadge $delay={300}>
          <BadgeIcon>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1M12 7C13.4 7 14.8 8.6 14.8 10V11.5C15.4 11.5 16 12.4 16 13V17C16 18.4 15.4 19 14.8 19H9.2C8.6 19 8 18.4 8 17V13C8 12.4 8.6 11.5 9.2 11.5V10C9.2 8.6 10.6 7 12 7M12 8.2C11.2 8.2 10.5 8.7 10.5 10V11.5H13.5V10C13.5 8.7 12.8 8.2 12 8.2Z" />
            </svg>
          </BadgeIcon>
          <BadgeTitle>{t('security.certifications.oauth.title')}</BadgeTitle>
          <BadgeDescription>{t('security.certifications.oauth.description')}</BadgeDescription>
        </ComplianceBadge>
      </ComplianceGrid>
    </StyledMetrics>
  );
};

export default SecurityMetrics;
